import type { IFuseOptions } from "fuse.js";
import type { Entry } from "../normalize";

export const FUSE_OPTIONS: IFuseOptions<Entry> = {
	keys: [
		{ name: "description", weight: 0.5 },
		// Fuse supports dot paths for nested fields.
		{ name: "matter.code", weight: 0.2 },
		{ name: "matter.description", weight: 0.1 },
		{ name: "matter.client", weight: 0.1 },
		{ name: "codes.task", weight: 0.04 },
		{ name: "codes.activity", weight: 0.04 },
		{ name: "application", weight: 0.02 },
	],
	threshold: 0.35,
	ignoreLocation: true,
	minMatchCharLength: 2,
};
